import { createStructuredSelector } from "reselect";
import {
    ACTIVE_INGREDIENT_LIST,
    ACTIVE_INGREDIENT_LIST_SUCCESS,
    ACTIVE_INGREDIENT_LIST_ERROR,
    ACTIVE_INGREDIENT_PAGE_SET,
    ACTIVE_INGREDIENT_HEADER,
    ACTIVE_INGREDIENT_SEARCH_SET,
    ACTIVE_INGREDIENT_SEARCH_CHANGE,
    ACTIVE_INGREDIENT_ADD_SET,
    ACTIVE_INGREDIENT_ADD_MODAL_SET,
    ACTIVE_INGREDIENT_ADD,
    ACTIVE_INGREDIENT_ADD_SUCCESS,
    ACTIVE_INGREDIENT_ADD_ERROR,
    ACTIVE_INGREDIENT_ADD_CHANGE,
    ACTIVE_INGREDIENT_EDIT_SET,
    ACTIVE_INGREDIENT_EDIT_CHANGE,
    ACTIVE_INGREDIENT_EDIT_MODAL_SET,
    ACTIVE_INGREDIENT_DETAIL,
    ACTIVE_INGREDIENT_DETAIL_SUCCESS,
    ACTIVE_INGREDIENT_DETAIL_ERROR,
    ACTIVE_INGREDIENT_UPDATE,
    ACTIVE_INGREDIENT_UPDATE_SUCCESS,
    ACTIVE_INGREDIENT_UPDATE_ERROR
} from "../actions";

export const NAME = 'activeIngredient';

export const ActiveIngredientList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: ACTIVE_INGREDIENT_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const ActiveIngredientListSuccess = (data) => ({
    type: ACTIVE_INGREDIENT_LIST_SUCCESS,
    payload: data
});

export const ActiveIngredientListError = (error) => ({
    type: ACTIVE_INGREDIENT_LIST_ERROR,
    payload: error
});

export const ActiveIngredientPageSet = (data) => ({
    type: ACTIVE_INGREDIENT_PAGE_SET,
    payload: data
});

export const ActiveIngredientHeader = (data) => ({
    type: ACTIVE_INGREDIENT_HEADER,
    payload: data
})

export const ActiveIngredientSearchSet = (data) => ({
    type: ACTIVE_INGREDIENT_SEARCH_SET,
    payload: data
});

export const ActiveIngredientSearchChangeSet = (data) => ({
    type: ACTIVE_INGREDIENT_SEARCH_CHANGE,
    payload: data
});


export const ActiveIngredientAddChangeSet = (data) => ({
    type: ACTIVE_INGREDIENT_ADD_CHANGE,
    payload: data
});

export const ActiveIngredientAddSet = (data) => ({
    type: ACTIVE_INGREDIENT_ADD_SET,
    payload: data
});

export const ActiveIngredientAddModalSet = (data) => ({
    type: ACTIVE_INGREDIENT_ADD_MODAL_SET,
    payload: data
});

export const ActiveIngredientAdd = (data) => ({
    type: ACTIVE_INGREDIENT_ADD,
    payload: data
});

export const ActiveIngredientAddSuccess = (message) => ({
    type: ACTIVE_INGREDIENT_ADD_SUCCESS,
    payload: message
});

export const ActiveIngredientAddError = (error) => ({
    type:ACTIVE_INGREDIENT_ADD_ERROR,
    payload: error
});

export const ActiveIngredientEditSet = (data) => ({
    type: ACTIVE_INGREDIENT_EDIT_SET,
    payload: data
});

export const ActiveIngredientEditChangeSet = (data) => ({
    type: ACTIVE_INGREDIENT_EDIT_CHANGE,
    payload: data
});

export const ActiveIngredientEditModalSet = (data) => ({
    type: ACTIVE_INGREDIENT_EDIT_MODAL_SET,
    payload: data
});

export const ActiveIngredientEditTabSet = (data) => ({
    type: ACTIVE_INGREDIENT_EDIT_TAB_SET,
    payload: data
});

export const ActiveIngredientDetail = (data) => ({
    type: ACTIVE_INGREDIENT_DETAIL,
    payload: data
});

export const ActiveIngredientDetailSuccess = (data) => ({
    type: ACTIVE_INGREDIENT_DETAIL_SUCCESS,
    payload: data
});

export const ActiveIngredientDetailError = (error) => ({
    type: ACTIVE_INGREDIENT_DETAIL_ERROR,
    payload: error
});

export const ActiveIngredientUpdate = (data) => ({
    type: ACTIVE_INGREDIENT_UPDATE,
    payload: data
});

export const ActiveIngredientUpdateSuccess = (message) => ({
    type: ACTIVE_INGREDIENT_UPDATE_SUCCESS,
    payload: message.message
});

export const ActiveIngredientUpdateError = (error) => ({
    type: ACTIVE_INGREDIENT_UPDATE_ERROR,
    payload: error
});



const activeIngredient = (state) => state[NAME];

export const ActiveIngredientSelector = createStructuredSelector({
    activeIngredient
})
